export default __webpack_public_path__ + "static/media/vocabulary-icon.d2fe0e21.png";